import {GetterTree, MutationTree, ActionTree} from 'vuex'
import {ServicesState, ServiceType, InventoryItem} from '@/store/types'
import ServiceModel from '@/classes/ServiceModel'
import LeadRoomInventoryModel from '@/classes/LeadRoomInventoryModel'
import axios from 'axios'

type ServicesGetter = GetterTree<ServicesState, any>
type ServicesMutation = MutationTree<ServicesState>
type ServicesAction = ActionTree<ServicesState, any>

const state: ServicesState = {
  services: [],
  serviceTypes: [],
  activeService: null,
  activeServiceType: null,
}


const getters: ServicesGetter = {
  services: (state) => state.services,
  serviceTypes: (state) => state.serviceTypes,
  availableServiceTypes: (state) => {
    const serviceTypes = state.serviceTypes.map((s) => s)
    state.services.forEach((service) => {
      const index = serviceTypes.findIndex((st) => st.id === service.additional_service_id)
      if (index >= 0) {
        serviceTypes.splice(index, 1)
      }
    })
    return serviceTypes.filter((st) => st.selectable)
  },
  activeService: (state) => state.activeService,
  activeServiceType: (state) => state.activeServiceType,
}

const mutations: ServicesMutation = {
  setServices: (state, services) => {
    state.services = services
  },
  setServiceTypes: (state, serviceTypes) => {
    state.serviceTypes = serviceTypes.filter((s: ServiceType) => s.type === 1)
  },
  addService: (state, service) => {
    state.services.push(service)
  },
  editService: (state, service) => {
    state.services = state.services.map((s) => s.id === service.id ? service : s)
  },
  removeService: (state, service) => {
    const index = state.services.findIndex((s) => s.name === service.name)
    if (index !== -1) {
      state.services = state.services.filter((s, i) => i !== index)
    }
  },
  setActiveService: (state, service) => {
    state.activeService = service
  },
  resetActiveService: (state) => {
    state.activeService = null
  },
  setActiveServiceType: (state, serviceType) => {
    state.activeServiceType = serviceType
  },
  resetActiveServiceType: (state) => {
    state.activeServiceType = null
  },
}

const actions: ServicesAction = {
  getServiceTypes: ({commit}) => {
    return new Promise((resolve, reject) => {
      axios.get('additional-services').then((response) => {
        commit('setServiceTypes', response.data.data)
        resolve(response.data.data)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  addNewService: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      axios.post('lead-additional-services', payload).then((response) => {
        commit('addService', response.data.data)
        if (response.data.data.name === ServiceModel.fullPack.name) {
          dispatch('syncInventoryFullPack')
        }
        dispatch('syncServices')
        resolve(response.data.data)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  editService: ({commit}, payload) => {
    return new Promise((resolve, reject) => {
      axios.put(`lead-additional-services/${payload.id}`, payload).then((response) => {
        commit('editService', response.data.data)
        resolve(response.data.data)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  removeService: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      let url = `lead-additional-services/${payload.id}`
      url += `?additional_service_id=${payload.additional_service_id}&lead_location_id=${payload.lead_location_id}`
      axios.delete(url).then((response) => {
        commit('removeService', payload)
        if (payload.name === ServiceModel.fullPack.name) {
          dispatch('syncInventoryFullPack')
        }
        dispatch('syncServices')
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  syncServices: ({state, commit, rootState}) => {
    let services = state.services
    // CRATING
    let cratingOn = false
    const cratingService = state.services.find((s) => s.name === ServiceModel.crating.name)
    rootState.inventory.inventory.forEach((i: InventoryItem) => {
      if (i.to_be_crated) {
        cratingOn = true
      }
    })
    if (cratingOn && cratingService === undefined) {
      services = services.concat(ServiceModel.crating)
    }
    if (!cratingOn && cratingService !== undefined) {
      services = services.filter((s) => s.name !== ServiceModel.crating.name)
    }
    // FULL PACK
    const fullPackService = state.services.find((s) => s.name === ServiceModel.fullPack.name)

    // PARTIAL PACK
    let partialPackOn = false
    const partialPackService = state.services.find((s) => s.name === ServiceModel.partialPack.name)
    rootState.inventory.inventory.forEach((i: InventoryItem) => {
      if (i.is_box && i.packed_by === LeadRoomInventoryModel.PACKED_BY.MOVERS) {
        partialPackOn = true
      }
    })
    if (partialPackOn && partialPackService === undefined && fullPackService === undefined) {
      services = services.concat(ServiceModel.partialPack)
    }
    if (!partialPackOn && partialPackService !== undefined || fullPackService !== undefined) {
      services = services.filter((s) => s.name !== ServiceModel.partialPack.name)
    }
    commit('setServices', services)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
